import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { ENDPOINT_MY_BONUS, ENDPOINT_MY_BONUS_GARAGE, PARAM_IDENTITYKIT, PARAM_VIN } from '../../endpoints';
import { Bonus, BonusFilter, PersonBonus } from '../models/bonus';
import { IEsOnehubVWConfig } from '../models/es-one-hub-config';

export const getMyBonus = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
): Promise<PersonBonus> => {
	const endpoint = ENDPOINT_MY_BONUS;

	const response = await authServiceInstance.get(esOnehubVWConfig.resourceHostId, endpoint, {
		'Content-Type': 'application/json',
	});

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}
	return response.json() as Promise<PersonBonus>;
};

export const getMyCarBonus = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	userIdentityKit: string,
	bonusFilter: BonusFilter,
): Promise<Response> => {
	const endpoint =
		ENDPOINT_MY_BONUS_GARAGE +
		'?' +
		[PARAM_IDENTITYKIT] +
		'=' +
		userIdentityKit +
		'&' +
		[PARAM_VIN] +
		'=' +
		bonusFilter.vin;

	const response = await authServiceInstance.get(esOnehubVWConfig.resourceHostId, endpoint, {
		'Content-Type': 'application/json',
	});

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}
	return response.json() as Promise<Response>;
};

export const getBonusById = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	bonusId: string,
): Promise<Bonus> => {
	const myBonus = await getMyBonus(authServiceInstance, esOnehubVWConfig);

	const { bonusEnjoyed, bonusForCars, bonusForYou } = myBonus.data;
	let bonusCars: Bonus[] = [];

	bonusForCars.forEach((car) => {
		bonusCars = [...bonusCars, ...car.bonus];
	});

	const allBonus = [...bonusEnjoyed, ...bonusCars, ...bonusForYou];

	const bonusDetail = allBonus.find((bonus) => bonus.id === bonusId);

	if (!bonusDetail) {
		return Promise.reject();
	}

	return Promise.resolve(bonusDetail);
};
